// extracted by mini-css-extract-plugin
module.exports = {"menu-container":"_3ex3nuoblwxOqtVePKh5GK","items-container":"_3BUdn8qxdLoxgfpqDSOxkJ"};